import { useState } from 'react';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../../../utils/Button';
import FocusControl from '../../../../../utils/FocusControl';
import { handleUpdatePackagePriceOpe } from '../../ProductOperation';
import { useProductDt } from '../ProductDetailsProvider';
import AddDurationType from './AddDurationType';
import AddLifetimeType from './AddLifetimeType';
import AddPpuType from './AddPpuType';

function InputByPackagePriceType({ type, formData, handleChange }) {
    if (type === 'duration') {
        return <AddDurationType formData={formData} handleChange={handleChange} update />;
    }
    if (type === 'ppu') {
        return <AddPpuType formData={formData} handleChange={handleChange} update />;
    }
    if (type === 'lifetime') {
        return <AddLifetimeType formData={formData} handleChange={handleChange} update />;
    }
    return null;
}

function UpdatePackagePriceModal({ closeModal, handleReload, data }) {
    const [formData, setFormData] = useState({
        Id: data?.id || 0,
        Currency: data?.currency || '',
        Amount: data?.amount || 0,
        VatPercent: data?.vatPercent || 0,
        Priority: data?.priority || 0,
        LimitByBillingCycle: data?.limitByBillingCycle || 0,
        LimitByValue: data?.limitByValue || 0,
        PackageUnitName: data?.packageUnitName || 'yearly',
        LimitByPPU: data?.limitByPPU || 0,
        Status: data?.status || 'active'
    });
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const { setMessage } = useTemplate();

    const { packageInfo } = useProductDt();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
    const handleEditCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        handleUpdatePackagePriceOpe(
            packageInfo?.applicationId,
            packageInfo?.id,
            data?.id,
            formData,
            setIsError
        )
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                handleReload();
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);
    return (
        <form onSubmit={handleEditCustomer}>
            <InputByPackagePriceType
                type={packageInfo?.limitBy}
                formData={formData}
                handleChange={handleChange}
            />
            <div className="flex gap-x-2 justify-end">
                <ButtonCancel title="Cancel" onClick={closeModal} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} onClick={null} />
            </div>
        </form>
    );
}

export default UpdatePackagePriceModal;
